<template id="template-personal-details">
  <div
    :dir="$store.state.rightAlign ? 'rtl' : 'ltr'"
    :class="isPreview ? 'pb-2 mb-2' : 'bg-light p-3 pb-5 mb-2'"
  >
    <!-- menu buttons -->
    <MenuButtons
      v-if="!isPreview"
      :fieldData="fieldData"
      :collapse="collapse"
      :isHidden="isHidden"
      :label="label"
      :sectionIndex="sectionIndex"
      :fieldIndex="fieldIndex"
      v-on:toggle-field="showSettings = !showSettings"
      v-on:collapse-field="collapse = !collapse"
    />

    <p
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
      :style="{ textAlign: 'left' }"
    >
      {{
        form1.enableSectionFieldEnumeration == 1
          ? sectionIndex + 1 + "." + (fieldIndex + 1)
          : " "
      }}
    </p>
    <!-- input content -->
    <b-collapse
      v-show="JSON.parse(!fieldData.isHidden) || !isPreview"
      class="card"
      id="collapse-1"
      v-model="collapse"
    >
      <div class="mt-3" :id="fieldData.id">
        <h4>{{ fieldData.label[selectedLanguage] }}</h4>
        <p>{{ fieldData.description[selectedLanguage] }}</p>
        <b-form-checkbox
          v-show="!fieldData.isNaFeature || fieldData.isNaFeature == 0"
          v-model="fieldData.isNa"
          @input="onToggleNa"
          value="1"
          unchecked-value="0"
          >N/A</b-form-checkbox>
      </div>
      <b-modal
        no-close-on-backdrop
        no-close-on-esc
        hide-header-close
        v-model="showAddRowModal"
        :title="
          isUpdtating
            ? $t('workflow.update') + ' ' + fieldData.label[selectedLanguage]
            : $t('workflow.add') + ' ' + fieldData.label[selectedLanguage]
        "
        size="xl"
      >
        <b-form v-for="(field, index) in fieldData.fields" :key="index">
          <!-- :invalid-feedback="$t('createProfile.requiredValidationMessage')" -->

          <b-form-group
            v-if="
              field.inputType == 'radio' ||
                field.inputType == 'select' ||
                field.inputType == 'checkbox'
            "
          >
            <label>
              <span v-if="field.validation.required" class="required-span"
                >*</span
              >
              {{ field.label[selectedLanguage] }}
            </label>
            <b-form-radio-group
              :options="field.options"
              :text-field="`text.${selectedLanguage}`"
              v-model="field.postValue"
            ></b-form-radio-group>
            <label
              v-if="field.validation.required && !field.postValue && isFocus"
              class="text-danger"
              >{{ $t("createProfile.requiredValidationMessage") }}</label
            >
          </b-form-group>

          <b-form-group
            v-else
            :invalid-feedback="
              hasXss(field.postValue)
                ? $t('createProfile.invalidInputMessage')
                : $t('createProfile.requiredValidationMessage')
            "
          >
            <label>
              <span v-if="field.validation.required == 1" class="required-span"
                >*</span
              >
              {{ field.label[selectedLanguage] }}
            </label>
            <b-form-input
              v-model="field.postValue"
              :type="field.inputType"
              :state="
                hasXss(field.postValue)
                  ? false
                  : field.validation.required == 0 || !isFocus
                  ? null
                  : field.validation.required == 1 && field.postValue
                  ? true
                  : false
              "
              @focus="isFocus = true"
            >
            </b-form-input>
          </b-form-group>
        </b-form>
        <template v-slot:modal-footer>
          <!-- @click="resetModal" -->
          <b-button variant="danger" @click="resetModal">{{
            $t("closeBtnText")
          }}</b-button>
          <b-button
            variant="success"
            @click="isUpdtating ? updateRow() : addRow()"
            >{{ isUpdtating ? $t("updateBtn") : $t("saveBtnText") }}</b-button
          >
        </template>
      </b-modal>
      <b-row v-if="taskStatus != 4" :id="fieldData.id">
        <b-col cols="12">
          <b-spinner v-if="isToggle" />
          <b-button
            :disabled="isDisabled == 1 || fieldData.isNa == 1"
            class="my-2"
            variant="outline-success"
            size="lg"
            @click="showAddRowModal = !showAddRowModal"
          >
            <font-awesome-icon icon="plus" />
            {{ $t("workflow.add") }}
          </b-button>
        </b-col>
      </b-row>

      <!-- ------table show -->
      <b-row class="mt-3">
        <b-col cols="12" class="p-5">
          <b-table-simple striped hover>
            <b-thead>
              <b-tr>
                <b-th v-for="(col, index) in fieldData.fields" :key="index"
                  >{{ col.label[selectedLanguage] }}
                </b-th>
                <b-th>{{ $t("upload.fileAction") }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(row, indexRow) in items" :key="indexRow">
                <b-td v-for="(item, indexCol) in row" :key="indexCol">{{
                  checkDisplayValue(item.displayValue)
                }}</b-td>
                <b-td>
                  <!-- temp disabled for complex work flow -->
                  <!-- <b-button
                    @click="onEditRow(row, indexRow)"
                    size="sm"
                    class="mr-1"
                  >
                    <font-awesome-icon
                      :icon="taskStatus != 4 ? 'edit' : 'eye'"
                    />
                  </b-button> -->
                  <b-button
                    @click="deleteRowShowModal(index, fieldData)"
                    variant="danger"
                    size="sm"
                    class="bt-small p-1"
                    v-if="taskStatus != 4"
                    id="delete-btn"
                    v-b-tooltip.hover
                    :title="$t('workflow.deleteHeaderText')"
                    :disabled="isDisabled == 1"
                  >
                    <font-awesome-icon size="2x" icon="trash" />
                  </b-button>
                  <!-- <b-tooltip target="delete-btn" triggers="hover">
                    Delete Row
                  </b-tooltip> -->
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-col>
      </b-row>

      <!-- show advance field options -->
      <b-modal
        cancel-title="Close"
        ok-title="save"
        @ok="onSaveData"
        size="xl"
        v-model="showSettings"
        scrollable
        title="Advanced Settings"
      >
        <AdvanceSettings
          :fieldData="fieldData"
          v-on:toggle-field="showSettings = !showSettings"
          :sectionIndex="sectionIndex"
          :fieldIndex="fieldIndex"
        />
      </b-modal>
    </b-collapse>
    <DeleteModal />
  </div>
</template>

<script>
import DeleteModal from "../deleteModal.vue";
import MenuButtons from "../menuButtons";
import AdvanceSettings from "../workflowSettings/advanceCustomWorkflowSettings.vue";
import { Helper, Validate } from "../../helpers";
import VSelect from "@alfsnd/vue-bootstrap-select";
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import { EventBus } from "@/event-bus.js";
import workflowRowDeleteMixin from "../../mixins/workflowRowDeleteMixin";

export default {
  name: "AdvanceCustomWorkflowGroup",
  mixins: [validationMixin, workflowRowDeleteMixin],
  components: {
    MenuButtons,
    VSelect,
    AdvanceSettings,
    DeleteModal,
  },
  computed: {
    ...mapGetters(["form1", "selectedLanguage"]),
  },
  data() {
    return {
      isToggle: false,
      showFreeForm: false,
      showAddRowModal: false,
      items: [],
      isHidden: false,
      condition: {},
      title: null,
      form: {},
      label: null,
      showSettings: false,
      collapse: true,
      isUpdtating: false,
      selectedRowIndex: null,
      postData: [],
      taskStatus: 0,
      noOfRows: [],
      isFocus: false,
    };
  },
  mounted() {
    if (this.$route.name == "userform") {
      this.getDataForUser();
    }
    let st = parseInt(localStorage.getItem("activeTaskStatus"));
    this.taskStatus = st;
  },

  validations() {
    return {
      form: {
        foreName: {
          [this.forename]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireForename
              ? required
              : !required,
        },
        emailAddress: {
          ["required"]:
            this.fieldData.validation &&
            this.fieldData.validation.isRequireEmail
              ? required
              : !required,
          email,
        },
      },
    };
  },

  created() {
    // delete Row on
    EventBus.$on("deletedRow", (data, selectedRowId) => {
      if (selectedRowId == this.fieldData.id) {
        this.onDeleteRow(data);
      }
    });
    //
    EventBus.$on("onSubmitEndUserForm", (value) => {
      if (
        value == "progress" ||
        this.fieldData.isNa == 1 ||
        this.fieldData.isHidden
      ) {
        this.$store.state.validFields = true;
        this.fieldData.isInValid = false;
        this.setDataToUser();
      } else {
        if (this.items && this.items.length > 0) {
          // console.log(" custom-workflow---------Passss--");
          this.setDataToUser();
          this.$store.state.validFields = true;
          this.fieldData.isInValid = false;
        } else {
          // console.log("---Fail-----custom-workflow contact");
          this.fieldData.isInValid = true;
          this.$store.state.validFields = false;
        }
      }
    });
    EventBus.$on("OnInvalidFieldCatch", (inValidData) => {
      // console.log("OnInvalidFieldCatch custom-workflow contact", inValidData, this.fieldData.id)
      document
        .getElementById(inValidData.elementId)
        .scrollIntoView({ behavior: "smooth" });
    });
  },

  methods: {
    onToggleNa(e) {
      this.isToggle = true;
      this.fieldData.isNa = e;
      this.isToggle = false;
       if(e == 1){
        this.items = []
        this.postData = []
      }
      
    },
    checkDisplayValue(value) {
      let valueType = typeof value;
      if(valueType == 'string') return value ;
      else return value.text[this.selectedLanguage];
    },
    hasXss(value) {
      return typeof value === "string" && !Validate.noXSS(value);
    },
    hasUnsafeInput() {
      return this.fieldData.fields.some((field) => this.hasXss(field.postValue));
    },
    addRow() {
      if (this.hasUnsafeInput()) {
        return;
      }
      let colDataForPost = [],
        colDataForShow = [];
      const registerData = _.clone(this.$store.state.registerData);
      this.$v.form.$touch();
      if (this.$v.form.$anyError && this.$v.form.$invalid) {
        return;
      }

      registerData[this.fieldData.id] = "custom-worlflow";
      this.$store.state.registerData = registerData;

      // main calculations :p
      const numkeys = Object.keys(registerData).length;
      this.$store.state.progressValue = numkeys;
      // console.log("this", this.fieldData.fields)
      let fields = _.cloneDeep(this.fieldData.fields);
      if (this.$route.name == "userform") {
        for (let ele of fields) {
          if (ele.validation.required == 1 && !ele.postValue) {
            this.isFocus = true;
            return false;
          }
        }

        //  let foindInvalid = fields.find(ele => ele.validation.required == 1 && (ele.postValue == null || ele.postValue == '') )
        console.log("foindInvalid",fields);
        for (let ele of fields) {
          let displayValue = ele.postValue;
          let index = ele.options.findIndex(
            (x) => x.value == ele.postValue
          )
          if(index != -1) {
            displayValue = ele.options[index];
          }
          let row = {
            rowId: ele.id,
            key: ele.name,
            label: ele.label[this.selectedLanguage],
            postValue: ele.postValue,
            displayValue: displayValue,
            postName: ele.name + "PostName",
          };
          colDataForShow.push(row);
          colDataForPost.push(row);

          this.resetModal(row);
        }
      }
      this.items.push(colDataForShow);
    },

    getDataForUser() {
      this.$store.state.getUserFormSubmitArray.map((data) => {
        if (
          data.elementId === this.fieldData.id ||
          data.elementTitle[this.selectedLanguage] ==
            this.fieldData.label[this.selectedLanguage]
        ) {
          this.fieldData.isNa = data.isWorkFlowNa;
          this.fieldData.isHidden = data.isHiddenElement == 1 ? true : false;
        }
        if (data.elements && data.elements.length > 0) {
          data.elements.map((element, index) => {
            if (
              data.elementId === this.fieldData.id ||
              data.elementTitle[this.selectedLanguage] ==
                this.fieldData.label[this.selectedLanguage]
            ) {
              this.items = data.elements;
              // this.postData = data.elements;
            }
          });
        }
      });
    },

    setDataToUser(row) {
      if (this.$route.name == "userform") {
        this.$store.state.userFormSubmitArray.map((a, index) => {
          if (
            a.elementId === this.fieldData.id ||
            a.elementTitle[this.selectedLanguage] ==
              this.fieldData.label[this.selectedLanguage]
          ) {
            // console.log("found custom workflow");
            a.isWorkFlowNa = this.fieldData.isNa;
            a.isHiddenElement = this.fieldData.isHidden ? 1 : 0;
            a.elements = this.items;
          }
        });
      }
    },

    updateRow() {
      if (this.hasUnsafeInput()) {
        return;
      }
      this.$v.form.$touch();
      if (this.$v.form.$anyError && this.$v.form.$invalid) {
        return;
      }
      this.resetModal();
    },

    // deleteRowShowModal(index) {
    //   EventBus.$emit("onShowDeletModal", index);
    // },

    onDeleteRow(index) {
      const registerData = _.clone(this.$store.state.registerData);
      if (this.items.length == 1) {
        delete registerData[this.fieldData.id];
        this.$store.state.registerData = registerData;

        // main calculations :p
        const numkeys = Object.keys(registerData).length;
        // const sectionLength = this.form1.formSection.length > 1 ? this.form1.formSection[this.sectionIndex].formElements.length : 1
        this.$store.state.progressValue = numkeys;
      }
      this.items.splice(index, 1);
      // this.postData.splice(index, 1);
    },

    onEditRow(item, index) {
      // this.items[this.selectedRowIndex].forename = this.form.foreName;
      // console.log("asasas", this.items[this.selectedRowIndex].rowId);

      for (let index in this.fieldData.fields) {
        // this.fieldData.fields.find(ele => ele.id == ) .postValue = null;
        console.log("this.fieldData.fields", this.items[index]);
        // this.fieldData.fields[index].postValue = 'yes'
      }
      this.isUpdtating = true;
      this.showAddRowModal = true;
      this.selectedRowIndex = index;
      this.form = {};
    },

    resetModal() {
      this.$v.$reset();
      for (let index in this.fieldData.fields) {
        this.fieldData.fields[index].postValue = null;
      }
      this.showAddRowModal = false;
      this.isUpdtating = false;
      this.isFocus = false;
    },

    onSaveData() {
      EventBus.$emit("onSaveSettings", "saving settings");
      Helper.makeToast(this.$bvToast, "success", "Settings updated");
    },
  },

  props: {
    fieldData: Object,
    isPreview: Boolean,
    sectionIndex: Number,
    fieldIndex: Number,
    isDisabled: Number,
  },
};
</script>
<style>
.bt-small {
  font-size: 8px !important;
}
</style>
